import { ConcreteEncodable } from "./ConcreteEncodable";

import { ProfileSettingImplEncoder } from "../../encoder/ProfileSettingImplEncoder";

import * as CubiqTS from "../../index";
import { ProfileSetting } from "../ProfileSetting";

export class ProfileSettingImpl extends ConcreteEncodable implements ProfileSetting {
  public static enType: string = "com.bcdfx.model.ProfileSettingImpl";

  /*FID=1*/
  public profileSettingKey: string;
  /*FID=2*/
  public profileSettingValue: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ProfileSettingImplEncoder.Instance;
    this.setEncodableType(ProfileSettingImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ProfileSettingImpl[" +
      "profileSettingKey=" +
      this.profileSettingKey +
      "profileSettingValue=" +
      this.profileSettingValue +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
